import { PostCard } from "@/components/feed/PostCard";
import { EmptyState } from "@/components/feed/EmptyState";
import { timeAgo } from "@/lib/feed";

const Skeleton = () => (
  <div data-testid="feed-loading" className="grid grid-cols-2 md:grid-cols-4 gap-2">
    {[...Array(6)].map((_, i) => (
      <div key={i} className={`aspect-square animate-pulse bg-[var(--ink-3)] ${i === 0 ? "md:col-span-2 md:row-span-2" : ""}`} />
    ))}
  </div>
);

export const PostGrid = ({ feed, loading, onOpen, trending }) => {
  const posts = feed?.posts || [];
  const url = feed?.profile?.url || "https://www.instagram.com/hostnode.cloud/";
  const lastSpan = posts.length > 1 ? 1 + ((4 - ((posts.length + 3) % 4)) % 4) : 1;
  return (
    <section data-testid="posts-section" className="px-6 md:px-12 lg:px-20 pb-28">
      <div className="flex flex-wrap items-end justify-between gap-4 border-t border-[var(--line)] pt-10 mb-10">
        <h2 className="font-display text-base md:text-lg italic text-[var(--ash)]">
          <span className="not-italic font-mono text-xs uppercase tracking-[0.3em] text-[var(--bone)] mr-4">01</span>
          Latest posts
        </h2>
        {feed?.fetched_at && (
          <span data-testid="feed-synced-at" className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--smoke)]">
            Synced {timeAgo(feed.fetched_at)}
          </span>
        )}
      </div>
      {loading ? (
        <Skeleton />
      ) : posts.length === 0 ? (
        <EmptyState url={url} unavailable={feed?.stale && !feed?.profile} />
      ) : (
        <div data-testid="posts-grid" className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {posts.map((p, i) => (
            <PostCard key={p.id} post={p} index={i} featured={i === 0} trending={trending.has(p.id)} span={i === posts.length - 1 ? lastSpan : 1} onOpen={() => onOpen(i)} />
          ))}
        </div>
      )}
    </section>
  );
};
